export const APP_TITLE = "DHH"
export const SECRET_KEY = 'secret key 123'